const linkedinUrl = 'https://www.linkedin.com/in/wyattolsenfinance/';
const handshakeUrl = 'https://app.joinhandshake.com/profiles/msxzh2';

module.exports = {
  email: 'wyatt-olsen@uiowa.edu',

  linkedinUrl,
  handshakeUrl,

  // Shown in the contact section. Set to null to hide it.
  phone: '319-834-0092',

  // The "Resume" button in the nav and mobile menu. Replace static/resume.pdf
  // to update it; set this to null to hide the button.
  resumeUrl: '/resume.pdf',

  // Icons down the left-hand rail. Add an entry and it appears; the rail hides
  // itself entirely while this list is empty.
  socialMedia: [
    {
      name: 'Linkedin',
      url: linkedinUrl,
    },
  ],

  // Every profile that is unambiguously this Wyatt Olsen. Feeds the `sameAs`
  // field of the Person structured data, which is how search engines tell this
  // Wyatt Olsen apart from the others.
  profileUrls: [linkedinUrl, handshakeUrl],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Education',
      url: '/#education',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#e2725b',
    navy: '#1b1613',
    darkNavy: '#14100d',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
